document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth > 749) return;

  const gallery = document.querySelector('[id^="Slider-Gallery"]');
  const dots = document.querySelectorAll('.zyvor-dots span');

  if (!gallery || !dots.length) return;

  function updateDots() {

    const slides = gallery.querySelectorAll('.product__media-item');
    const slideWidth = gallery.clientWidth;

    const index = Math.round(gallery.scrollLeft / slideWidth);

    dots.forEach(dot => dot.classList.remove('active'));

    if (dots[index]) {
      dots[index].classList.add('active');
    }
  }

  // throttle for smooth performance
  let ticking = false;

  gallery.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateDots();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  updateDots();

});